import { render, staticRenderFns } from "./testPaperAdd.vue?vue&type=template&id=7e43c0c8&scoped=true"
import script from "./testPaperAdd.vue?vue&type=script&lang=js"
export * from "./testPaperAdd.vue?vue&type=script&lang=js"
import style0 from "./testPaperAdd.vue?vue&type=style&index=0&id=7e43c0c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e43c0c8",
  null
  
)

export default component.exports